/**
PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *  Copyright © 2026 Pearson Education, Inc.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
* */

/**
 * Mapped Card Header component
 *
 * @file SubscriptionStatusBtn.jsx
 * @author Ujjwal Sana
 * @since 1.2.8
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import mixins from '../../assets/styles/mixins.scss';
import CommonStyles from '../../assets/styles/CommonStyles';

const SUBSCRIPTION_STATUS_LABEL_TYPOGRAPHY = CommonStyles().subscriptionStatusLabel;

const StyledContainer = styled(Typography)({
  '&&': {
    display: 'inline-flex',
    minHeight: '32px',
    boxSizing: 'border-box',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '4px 12px',
    borderRadius: 4,
    color: mixins.upgradeAccessColor,
    background: mixins.upgradeAccessBGColor,
    fontFamily: mixins.fontFamilyPlusSans,
    fontStyle: 'normal',
    lineHeight: '16px',
    width: 'fit-content',
    ...SUBSCRIPTION_STATUS_LABEL_TYPOGRAPHY,

    '&.subscribed': {
      color: mixins.partOfSubscriptionBGColor,
      background: mixins.accentBlueTextColor,
      flex: 'none',
      marginLeft: 8
    }
  },
  '&&&.MuiTypography-body1': SUBSCRIPTION_STATUS_LABEL_TYPOGRAPHY
});

const SubscriptionStatusBtn = ({
  classes,
  text,
  isSubscribed = true
}) => (
  <StyledContainer
    className={`${classes?.container || ''} ${isSubscribed ? 'subscribed' : 'unsubscribed'}`.trim()}
  >
    {text}
  </StyledContainer>
);

SubscriptionStatusBtn.defaultProps = {
  classes: {},
  text: '',
  isSubscribed: true
};

SubscriptionStatusBtn.propTypes = {
  classes: PropTypes.object,
  text: PropTypes.string,
  isSubscribed: PropTypes.bool
};

const SubscriptionStatusBtnWithStyles = (props) => {
  const { classes: parentClasses = {}, ...rest } = props;

  return <SubscriptionStatusBtn {...rest} classes={parentClasses} />;
};

SubscriptionStatusBtnWithStyles.propTypes = {
  classes: PropTypes.object
};

SubscriptionStatusBtnWithStyles.defaultProps = {
  classes: {}
};

export default SubscriptionStatusBtnWithStyles;
